import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import Header from '../components/header';
import { validateEmail } from '../utils/validator';
import request from '../core/request';
import { env } from '../utils/const';
const { REACT_APP_AUTH_API } = process.env

const ForgotPassword = () => {
  const history = useHistory();
  const [state, setState] = useState({
    email: '',
    emailError: '',
  });
  const handleState = (value, key) => {
    setState({ ...state, [key]: value, [key + 'Error']: '' });
  };

  const handleSubmit = async () => {
    console.log(env.REACT_APP_AUTH_API,REACT_APP_AUTH_API,'request');
    let isValid = true;
    let localState = state;
    const emailValidation = validateEmail(state.email);
    if (!emailValidation.isValid) {
      isValid = false;
      localState = { ...localState, emailError: emailValidation.message };
    }
    if (isValid) {
      let { data, status } = await request.post(`/user/forgotpassword`, {
        email: state.email,
      });
      if (status >= 400) {
        toast.error(data.message);
      }
      if (status >= 200 && status < 300) {
        toast.success('Reset password link is sent to your email');
        history.push('/');
      }
    } else {
      setState(localState);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSubmit();
    }
  };

  return (
    <div className="auth-page-centered">
      <div className="auth-form-centered">
        <div className="auth-card">
          <div className="auth-logo-centered">
            <Header />
          </div>
          <div className="auth-card-header">
            <h2>Forgot Password</h2>
            <p>Enter your email and we'll send you a reset link</p>
          </div>

          <div className="form-group">
            <input
              type="email"
              id="email"
              placeholder="Email address"
              name="email"
              className="form-input"
              value={state.email}
              onChange={({ target }) => {
                handleState(target.value, 'email');
              }}
              onKeyPress={handleKeyPress}
              autoComplete="email"
            />
            {state?.emailError && <div className="form-error">{state.emailError}</div>}
          </div>

          <button className="btn-primary" onClick={handleSubmit}>
            Send Reset Link
          </button>

          <div
            className="auth-link-btn"
            onClick={() => {
              history.push('/');
            }}
          >
            Back to <span>Sign In</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
